export default __webpack_public_path__ + "static/media/hagglefish.5504c777.jpg";